import React, { Component } from 'react';
import Select from 'react-select';
import {actions, connect} from 'mirrorx';
import 'react-select/dist/react-select.css';

// ALL PLUGINS

import FountainToJsonExporter from '../exporters/fountain-to-json';
import FountainToPdfExporter from '../exporters/fountain-to-pdf';
import GenericExporter from '../exporters/generic';

let download = require('downloadjs');

class SidebarExporter extends Component {
	state = {
    	selectedOption: '',
    	options: []
	}
	constructor() {
		super();
		this.exporters = [];
		this.exporters.push(new GenericExporter());
		this.exporters.push(new FountainToJsonExporter());
		this.exporters.push(new FountainToPdfExporter());
	}
	handleChange = (selectedOption) => {
		this.setState({ selectedOption });
	}

	build = () => {
		if (!this.state.selectedOption ) {
			return;
		}

		actions.layout.setIsLoading(true);

		let exporter = this.exporters[this.state.selectedOption.value];
		exporter.export(this.props.editor.text).then(output => {
			actions.layout.setIsLoading(false);
			download(output, 'build'+exporter.getFileType(),
				exporter.getMimeType());
		}).catch(err => {
			// TODO: actually handle the error
			actions.layout.setIsLoading(false);
			console.log(err);
		});
	}

	componentDidMount() {
		let optionsList = [];
		for (let i = 0; i < this.exporters.length; i++) {
			let exporter = this.exporters[i];
			let op = {
				label: exporter.getName(),
				value: i
			};
			optionsList.push(op);
		}
		this.setState({
			options: optionsList
		});
	}
	render() {
		return (
			<div>
				<h2>Build Document</h2>
				<Select
		       		 name="form-field-name"
			        value={this.state.selectedOption ? this.state.selectedOption.value : null}
			        onChange={this.handleChange}
			        options={this.state.options}
			     />

	      		<hr />

			    <p>{this.state.selectedOption ? this.exporters[this.state.selectedOption.value].getDescription() : null}</p>

			    <button onClick={this.build} disabled={!this.state.selectedOption} className='btn'>Build</button>
	      	</div>

	     )
	}
}


export default connect(state => {
  return {editor: state.editor}
}, null, null, { withRef: true })(SidebarExporter);


// WEBPACK FOOTER //
// ./src/components/sidebar-exporter.js